import React from "react";
import { Form, Input, Button, Row, Col, Select } from "antd";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";

const { Option } = Select;

/**
 * 航段过滤器组件
 * @param {Object} props
 * @param {Function} props.onSearch - 搜索回调函数
 * @param {Function} props.onReset - 重置回调函数
 */
const FlightLegFilter = ({ onSearch, onReset }) => {
    const [form] = Form.useForm();

    // 重置表单
    const handleReset = () => {

        form.resetFields();
        onReset();
    };

    // 提交表单
    const handleFinish = (values) => {

        onSearch(values);
    };

    return (
        <Form form={form} layout="horizontal" onFinish={handleFinish} className="filter-form" labelAlign="right">
            <Row gutter={24}>
                <Col span={5}>
                    <Form.Item label="出发机场" name="departure_airport">
                        <Input placeholder="请输入出发机场" allowClear />
                    </Form.Item>
                </Col>
                <Col span={5}>
                    <Form.Item label="到达机场" name="arrival_airport">
                        <Input placeholder="请输入到达机场" allowClear />
                    </Form.Item>
                </Col>
                <Col span={5}>
                    <Form.Item label="航段编号" name="leg_number">
                        <Input placeholder="请输入航段编号" allowClear />
                    </Form.Item>
                </Col>
                <Col span={5}>
                    <Form.Item label="状态" name="is_active">
                        <Select placeholder="请选择状态" allowClear>
                            <Option value={true}>启用</Option>
                            <Option value={false}>停用</Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={4} style={{ textAlign: "right" }}>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" icon={<SearchOutlined />} style={{ marginRight: 8 }}>
                            搜索
                        </Button>
                        <Button icon={<ReloadOutlined />} onClick={handleReset} style={{ marginRight: 8 }}>
                            重置
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default FlightLegFilter;
